import React from 'react';

const ContainerContext = React.createContext(null);

export default ContainerContext;
